<template>
  <div>
    <table class="table">
      <thead>
      <tr>
        <th>Source</th>
        <th>Code</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="source in referralSources" :key="source.id">
        <td>
          <div v-if="editingSource === source.id">
            <input type="text" class="input" v-model="edit_source_name">
          </div>
          <div v-else>
            {{ source.name }}
          </div>
        </td>
        <td>
          <div v-if="editingSource === source.id">
            <input type="text" class="input" v-model="edit_source_code">
          </div>
          <div v-else>
            {{ source.code }}
          </div>
        </td>
        <td>
          <div v-if="editingSource === source.id">
            <button type="button" class="button is-primary" @click="updateSource">Save</button>
            <button type="button" class="button is-default" @click="stopEditing">Cancel</button>
          </div>
          <div v-else>
            <button type="button" class="button is-default" @click="editSource(source)">Edit</button>
            <button type="button" class="button is-default" @click="deleteSource(source)">Delete</button>
          </div>
        </td>
      </tr>
      <tr v-if="!addingSource">
        <td>
          <button type="button" class="button is-success" @click="addSource">Add New Source</button>
        </td>
        <td></td>
        <td></td>
      </tr>
      <tr v-if="addingSource">
        <td>
          <input type="text" class="input" v-model="add_source_name" placeholder="Source Name">
        </td>
        <td>
          <input type="text" class="input" v-model="add_source_code" placeholder="Code">
        </td>
        <td>
          <button type="button" class="button is-primary" @click="createSource">Create</button>
          <button type="button" class="button is-default" @click="stopEditing">Cancel</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import * as types   from "../../store/mutation-types"

export default {
  name: 'referral_sources',
  data() {
    return {
      addingSource: false,
      add_source_name: null,
      add_source_code: null,
      editingSource: false,
      edit_source_name: null,
      edit_source_code: null,
    }
  },
  computed: {
    ...mapGetters(['referralSources']),
  },
  methods: {
    addSource() {
      this.add_source_name = null
      this.add_source_code = null
      this.addingSource    = true
    },
    editSource(source) {
      this.edit_source_name = source.name
      this.edit_source_code = source.code
      this.editingSource    = source.id
    },
    stopEditing() {
      this.add_source_name  = null
      this.add_source_code  = null
      this.addingSource     = false
      this.edit_source_name = null
      this.edit_source_code = null
      this.editingSource    = false
    },
    createSource() {
      this.$store.dispatch(types.CREATE_REFERRAL_SOURCE, {
        name: this.add_source_name,
        code: this.add_source_code,
      }).then(data => {
        this.stopEditing();
      }).catch(error => {
        this.stopEditing();
      })
    },
    updateSource() {
      this.$store.dispatch(types.UPDATE_REFERRAL_SOURCE, {
        id: this.editingSource,
        name: this.edit_source_name,
        code: this.edit_source_code,
      }).then(data => {
        this.stopEditing();
      }).catch(error => {
        this.stopEditing();
      })
    },
    deleteSource(source) {
      this.$store.dispatch(types.DELETE_REFERRAL_SOURCE, {
        id: source.id,
      }).then(data => {
        this.stopEditing();
      }).catch(error => {
        this.stopEditing();
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReferralCodes.vue?515a3a4a